import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faThLarge } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { flatMap, union, difference, uniq } from 'lodash';
import React, { useEffect, useState, useMemo } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { TStepsOption } from '../../../../api/endpoints/SubsetOption';
import { sortNumbers } from '../../../../utils/Array';
import Checkbox from '../../../Inputs/Checkbox/Checkbox';
import Index from '../../../Ui/CheckboxWrap';
import Col from '../../../Common/Col';
import Row from '../../../Common/Row';
import StepsByDayAndIncrementControl from '../StepsByDayAndIncrementControl';
import { deriveSteps } from '../../../../utils/StepItem';
import SelectAllControl from "../../SelectAllControl";

const StepOptionsControl = (props: {
  spec: TStepsOption;
  values: Array<string>;
  onChange: (values: Array<string>) => void;
}) => {
  const { spec, values, onChange } = props;

  const [selectedSteps, setSelectedSteps] = useState<Array<number>>(values.map(v => parseInt(v, 10)));

  const options = useMemo(
    () => flatMap(spec.value.step, stepItem => deriveSteps(stepItem)),
    [spec.value.step]
  );

  useEffect(() => {
    onChange(sortNumbers(selectedSteps).map(v => v.toString()));
  }, [selectedSteps])

  const onDayOrIncrementChange = (newValues: Array<number>, strategy: 'add' | 'remove' | 'overwrite') => {
    switch (strategy) {
      case 'add':
        setSelectedSteps(union(selectedSteps, newValues));
        return;
      case 'remove':
        setSelectedSteps(difference(selectedSteps, newValues));
        return;
      case 'overwrite':
        setSelectedSteps(newValues)
        return;
    }
  }

  const onStepCheckboxChange = (value: number, checked: boolean) => {
    setSelectedSteps(checked ? [...selectedSteps, value] : selectedSteps.filter(v => v !== value));
  };

  return (
    <div className="steps-selector">
      <Tab.Container
        defaultActiveKey="aggregated-steps"
        transition={false}
        id="steps-selector"
      >
        <Row>
          <Col className="selection-controls">
            <SelectAllControl onChange={setSelectedSteps} values={options} />
          </Col>
          <Col className="steps-selector-tabs">
            <Nav variant="pills">
              <Nav.Item>
                <Nav.Link eventKey="aggregated-steps" title="Select by day">
                  <FontAwesomeIcon icon={faCalendar} />
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="all-steps" title="Select by step">
                  <FontAwesomeIcon icon={faThLarge} />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>

        <Row>
          <Col className="steps-selector-content">
            <Tab.Content>
              <Tab.Pane eventKey="aggregated-steps">
                <StepsByDayAndIncrementControl
                  values={selectedSteps}
                  valuesPool={options}
                  onChange={onDayOrIncrementChange}
                />
              </Tab.Pane>

              <Tab.Pane eventKey="all-steps">
                <Index>
                  {
                    options.map(option => {
                      return <Checkbox
                        key={option}
                        label={option.toString()}
                        value={option}
                        checked={(selectedSteps).includes(option)}
                        name="step-ranges"
                        onChange={(checked) => onStepCheckboxChange(option, checked)}
                      />;
                    })
                  }
                </Index>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>

  );
};

export default StepOptionsControl;
